import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CodeEditorModule } from '@ngstack/code-editor';
import { EaiChatModule } from '@corvus-it-poland/eai-chat';
import { AuthInterceptorInterceptor } from './@auth/interceptors/auth-interceptor.interceptor';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { environment } from '../environments/environment';
import { ErrorsInterceptor } from './@errors/errors.interceptor';
import { ToastComponent } from './cms/shared/components/toast/toast.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatNativeDateModule,
    NgJsonEditorModule,
    TranslocoModule,
    TranslocoRootModule,
    CodeEditorModule.forRoot({ baseUrl: 'assets/monaco' }),
    AngularSvgIconModule.forRoot(),
    MarkdownModule.forRoot(),
    EaiChatModule.forRoot({
      enabled: true,
      apiUrl: 'https://api.quick-ai.corvus-it.com',
      cmsUrl: 'https://cms.stable.quick-ai.corvus-it.com',
      socketUrl: 'wss://api.quick-ai.corvus-it.com',
      markdownEditorUrl: environment.markdownEditorUrl,
      localStoragePrefix: 'eai-chat',
      env: environment.envName,
      iFrameMode: false,
      provider: '',
    }),
    ToastrModule.forRoot({
      toastComponent: ToastComponent,
    }),
    StoreModule.forRoot(),
    EffectsModule.forRoot(),
  ],
  providers: [
    {
      provide: MatDialogRef,

      useValue: {},
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    provideCharts(withDefaultRegisterables()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
